import { Flex, Icon, IconName, modeColor, Popover, PopperHeader, setAlpha, Text, usePopoverState } from '@talos/kyoko';
import { useTheme } from 'styled-components';
import { PreTradeKBLinkButton } from './PreTradeKBLinkButton';

export function PreTradeKBInfoTooltip({ title, description }: { title: string; description: string }) {
  const theme = useTheme();
  const popover = usePopoverState({
    trigger: 'click',
    placement: 'right-start',
    closeOnClickOutside: true,
    noPaddingAndBorder: true,
  });

  return (
    <Popover {...popover}>
      <Icon icon={IconName.QuestionMarkCircle} size="fontSizeDefault" color="colorTextSubtle" />
      <Flex
        flexDirection="column"
        w="320px"
        background="gray.040"
        borderRadius="3px"
        border={`1px solid ${setAlpha(0.08, theme.colors.gray['100'])}`}
        boxShadow={`0px 8px 16px ${modeColor(theme, theme.colors.black.mute, setAlpha(0.24, theme.colors.gray['000']))}`}
        overflow="hidden"
      >
        <PopperHeader
          icon={IconName.BookOpen}
          titlePrefix="Pre-Trade"
          title={title}
          onCloseClicked={popover.close}
          boxProps={{ background: 'gray.020', borderRadius: '0' }}
        />
        <Flex flexDirection="column" gap="spacing8" p="spacing12" pt="spacing8">
          <Text color="colorTextDefault" size="fontSizeSmall">
            {description}
          </Text>
          <Flex alignSelf="flex-start">
            <PreTradeKBLinkButton label="Continue Reading" showStartIcon={false} />
          </Flex>
        </Flex>
      </Flex>
    </Popover>
  );
}
